import { render, staticRenderFns } from "./CSImage.vue?vue&type=template&id=2d8e6e4a&scoped=true"
import script from "./CSImage.vue?vue&type=script&lang=ts"
export * from "./CSImage.vue?vue&type=script&lang=ts"
import style0 from "./CSImage.vue?vue&type=style&index=0&id=2d8e6e4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e6e4a",
  null
  
)

export default component.exports